module.exports = __webpack_public_path__ + "static/img/jp1-1.5ea453c.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/jp1-1.png
// module id = 911
// module chunks = 0